import styled from "styled-components";

export const FooterMain = styled.footer`
  background-color: var(--white);

  .footer_row {
    display: flex;
    padding-top: 50px;
    justify-content: space-between;

    @media screen and (max-width: 992px) {
      justify-content: space-between;
      padding-top: 25px;
      flex-wrap:wrap;
      gap:20px;
    }

    > div {
      &:nth-child(1),
      &:nth-child(2) {
        margin-right: 0px;
      }

      @media screen and (max-width: 992px) {
        margin-right: 0;
      }
    }
    > .footer_links {
      // width: 25%;
      @media screen and (max-width: 992px) {
        width: 100%;
         &:nth-child(1),
         &:nth-child(2){
         width: 45%;
        }
        &:nth-child(3),&:last-child{
        text-align:center;
        >a{
        width:100%;
        justify-content:center;
        }
        }
      }

      > .linkHeadin {
        font-size: 20px;
        font-weight: 500;
        margin: 0 0 15px 0;
        color:var(--darkYellow);

        @media screen and (max-width: 575px) {
          font-size: 16px;
        }
      }
        > a {
        display: block;
        width: fit-content;
        font-size: 18px;
        color: var(--dark);
        margin-bottom: 10px;
        transition: 0.4s;
        font-weight: 400;
        font-family: var(--monserrat);
        border-bottom: 1px solid transparent;
        // opacity: 0.6;
        display: flex;
        align-items: center;
        column-gap: 5px;

        @media screen and (max-width: 767px) {
          font-size: 15px;
          white-space: nowrap;
        }
        @media screen and (max-width: 575px) {
          font-size: 14px;
        }

        @media screen and (max-width: 450px) {
          font-size: 13px;
        }

        > .badge {
          background-color: #b6510c;
          padding: 3px 5px;
          border-radius: 5px;
          font-size: 10px;
          color: var(--white);
          opacity: 1 !important;

          @media screen and (max-width: 350px) {
            padding: 3px;
          }
        }

        &:hover {
          border-bottom: 1px solid var(--choco);
          opacity: 1;
         
        }
          
                    
                    
  
      }
        >.links{
  display: flex;
  column-gap: 20px;
  align-items: center;
  margin-bottom: 20px;
          @media screen and (max-width: 992px) {
            column-gap: 15px;
            justify-content:center;

        }
  >a{
        display: block;

        width: fit-content;
        font-size: 18px;
        color: var(--yellow);
        transition: 0.4s;
        font-weight: 400;
        font-family: var(--monserrat);
        width:30px;
        height:30px;
         display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  &:hover {
    background-color: var(--txt);
  }

        @media screen and (max-width: 575px) {
                    font-size: 14px;



        }
                    
                    &:hover{

                    text-decoration:none;
                    
                    }
  }
}

      
    }
    > .feedback_form {
      width: 40%;
      @media screen and (max-width: 767px) {
        display: none;
      }
      > div {
        > h2 {
          font-size: 22px;
          font-family: var(--monserrat);
          margin-bottom: 20px;
          text-align: center;
          font-weight: 500;

          @media screen and (max-width: 767px) {
            font-size: 18px;
            margin-bottom: 15px;
          }
        }
        > input {
          width: 100%;
          height: 40px;
          border-radius: 8px;
          backdrop-filter: blur(21px);
          background: var(--yellow);
          border: none;
          outline: none;
          padding: 10px;
          box-sizing: border-box;
          color: var(--blue);
          margin-bottom: 20px;
          @media screen and (max-width: 767px) {
            margin-bottom: 15px;
          }
        }
        > button.feedback_btn {
          font-style: normal;
          font-weight: 400;
          text-transform: capitalize;
          background-color: transparent;
          padding: 10px 15px;
          display: block;
          margin: 0 auto;
          font-size: 14px;
          color: var(--white);
          border: 1px solid var(--white););
          border-radius: 8px;
          cursor: pointer;

          &:hover {
            color: var(--yellow);
            background-color: var(--white););
          }
        }
      }
    }
  }


  .social_links {
    display: flex;
    justify-content: space-between;
    padding-top: 30px;

    @media screen and (max-width: 767px) {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    > .app_link {
      // width: 40%;
      @media screen and (max-width: 767px) {
        &:last-child {
          margin-top: 30px;
        }
      }
      @media screen and (max-width: 480px) {
        width: 100%;
      }
      > p {
        text-align: center;
        font-size: 16px;
        margin-bottom: 15px;
      }
      > .links {
        display: flex;
        align-items: center;
        justify-content: center;

        @media screen and (max-width: 370px) {
          flex-wrap: wrap;
          row-gap: 15px;
        }

        > a {
          color: var(--white);
          font-size: 20px;
          margin: 0 15px;
          &:hover {
            color: var(--yellow);
          }
        }
      }
    }
  }

  p.copyright_txt {
    font-size: 16px;
    text-align: center;
    width: 100%;
    display: block;
    margin: 0 auto;
    margin-top: 30px;
    padding:10px 0px;
    background: linear-gradient(90deg, var(--yellow), var(--darkYellow));

    @media screen and (max-width: 767px) {
      font-size: 14px;
    }
    @media screen and (max-width: 575px) {
      font-size: 14px;
      width: 100%;
    }
  }
`;
